export * from './lib/shared-lib1.module';
